const initilaState = [];

export const R_searchText = (state = initilaState, action) => {
  switch (action.type) {
    case "Search_Text":
      return { ...action.payload };

    default:
      return state;
  }
};